let load_remote_modal = (actionData) => {
    window.Smart.remoteModal.load(actionData.url, actionData.modalDialogClass, actionData.modalContentClass);
};
export default load_remote_modal;
